import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: '**', pathMatch: 'full', redirectTo: '/public/login/' },
];

export const AppRoutingModule = RouterModule.forRoot(routes);
